export default __webpack_public_path__ + "static/media/close-sharp.83ccd232.svg";